/**
 * TelemetryAgent EventWidget
 * Javascript Library
 * Version 4.1.29
 */
var TelemetryAgentEventWidget = (function() {
    var instance;


    var thisScript = (function() {
        var ScriptID = "ScriptID" + Math.round(100000 * Math.random());
        document.write("<script id='" + ScriptID + "'></script>");
        return document.getElementById(ScriptID).previousSibling.getAttribute("src");
    });
    var scripts = document.getElementsByTagName("script"),
        src = scripts[scripts.length - 1].src;
    var currentScriptChunks = src.split('/');
    var currentScriptFile = currentScriptChunks[currentScriptChunks.length - 1];


    var widgetPath = src.replace(currentScriptFile, '');



    var createInstance = function(config) {

        $options = config;
        this.$widgetOptions = $options || {};


        this.$defaults = {
            EventContainerId: 'eventDiv', // ID of the container
            ContainerWidth: 'auto',
            Heading: 'Events',
            ProjectApiKey: '',
            ApiUrl: '',
            PartyId: '',
            ReleaseStage: '',
            recordLimit: 5,
            defaultDays: 7,
            startDate: '',
            endDate: '',

        };
        this.params = {
            eventTableClass: 'event-table-list',
            preloaderClass: 'preloader-conatiner',
            paginationContainerClass: 'event-pagination-container',
            // html tag
            labelTag: "<label>",
            formTag: "<form>",
            inputTag: "<input>",
            selectTag: "<select>",
            optionTag: "<option>",
            ulTag: "<ul>",
            liTag: "<li>",
            spanTag: "<span>", // html tag  
            divTag: "<div>",
            tableTag: "<table>",
            closeTableTag: "</table>",
            headerColumnTag: "<th>",
            headerCloseColumnTag: "</th>",
            rowTag: "<tr>",
            closeRowTag: "</tr>",
            columnTag: "<td>",
            closeColumnTag: "</td>",
            aTag: "<a>",
            buttonTag: "<button>",
            h4Tag: "<h4>", // html h4 tag 


        };
        this.defaultFields = [{
            "value": "logged_at",
            "name": "Visited Date",
            "status": true
        }, {
            "value": "ip_address",
            "name": "Ip Address",
            "status": true
        }, {
            "value": "user_name",
            "name": "User Name",
            "status": true
        }, {
            "value": "email",
            "name": "Email",
            "status": true
        }, {
            "value": "category",
            "name": "Category",
            "status": true
        }, {
            "value": "action",
            "name": "Action",
            "status": true
        }, {
            "value": "label",
            "name": "Label",
            "status": true
        }, {
            "value": "value",
            "name": "Value",
            "status": true
        }, {
            "value": "source_description",
            "name": "Source",
            "status": false
        }, {
            "value": "browser_name",
            "name": "Browser",
            "status": false
        }, {
            "value": "browser_version",
            "name": "Browser Version",
            "status": false
        }, {
            "value": "platform_name",
            "name": "Os",
            "status": false
        }, {
            "value": "os_version",
            "name": "Os Version",
            "status": false
        }, {
            "value": "session_unique_id",
            "name": "Session Unique Id",
            "status": false
        }, {
            "value": "country_name",
            "name": "Country",
            "status": false
        }, {
            "value": "city_name",
            "name": "City",
            "status": false
        }, {
            "value": "latitude",
            "name": "Latitude",
            "status": false
        }, {
            "value": "longitude",
            "name": "Longitude",
            "status": false
        }];
        this.fields = this.defaultFields;
        this.countryList = [];
        this.categoryList = [];
        this.ipList = [];
        this.events = {};
        this.customFields = [];
        this.selectedCustomFields = [];
        this.widgetPath = config.widgetPath;
        var $ewi = this;

        this.init = function() {
            var scripts = document.getElementsByTagName("script"),
                src = scripts[scripts.length - 1].src;

            var jQuery;

            if (window.jQuery === undefined || window.jQuery.fn.jquery !== '1.7.1') {
                var script_tag = document.createElement('script');
                script_tag.setAttribute("type", "text/javascript");
                script_tag.setAttribute("src",
                    $ewi.widgetPath + "js/jquery-1.7.2.min.js");
                if (script_tag.readyState) {
                    script_tag.onreadystatechange = function() { // For old versions of IE
                        if (this.readyState == 'complete' || this.readyState == 'loaded') {
                            scriptLoadHandler();
                        }
                    };
                } else { // Other browsers
                    script_tag.onload = scriptLoadHandler;
                }
                (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
            } else {
                jQuery = window.jQuery;

                main(); //our main JS functionality
            }



        }
        $ewi.init();

        function scriptLoadHandler() {
            jQuery = window.jQuery.noConflict(true);

            main(); //our main JS functionality
        }

        function main() {
            jQuery(document).ready(function($) {

                $ewi.options = jQuery.extend({}, $ewi.$defaults, $ewi.$widgetOptions);
                $ewi.startDate = getDefaultStartDate();
                $ewi.endDate = getDefaultEndDate();
                var widgetCSS = jQuery("<link>", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: $ewi.widgetPath + "css/jquery-ui.css"
                });
                widgetCSS.appendTo('head');
                var jQueryUi = document.createElement('script');
                jQueryUi.setAttribute("type", "text/javascript");
                jQueryUi.setAttribute("src",
                    $ewi.widgetPath + "js/jquery-ui-1.10.2.custom.min.js");
                document.getElementsByTagName('head')[0].appendChild(jQueryUi);
                if (!jQuery().pagination) {
                    var simplePaginationJs = document.createElement('script');
                    simplePaginationJs.setAttribute("type", "text/javascript");
                    simplePaginationJs.setAttribute("src",
                        $ewi.widgetPath + "js/jquery.simplePagination.js");
                    document.getElementsByTagName('head')[0].appendChild(simplePaginationJs);
                }
                var widgetPaginationCSS = jQuery("<link>", {
                    rel: "stylesheet",
                    type: "text/css",
                    href: $ewi.widgetPath + "css/simplePagination.css"
                });
                widgetPaginationCSS.appendTo('head');





                var container = $('#' + $ewi.options.EventContainerId);


                var divContent = jQuery($ewi.params.divTag).attr({
                    'class': "stats-content fade-in-up ng-scope"
                }).css({
                    'overflow': 'hidden',
                    'font-family': 'sans-serif',
                    'color': '#333333'
                });
                jQuery(container).append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({ 'class': "portlet light" })
                    .css({
                        'background-color': '#fff',
                        'padding': '12px 20px 15px',
                        'border-radius': '4px',
                        'margin-bottom': '25px',
                        'margin-top': '0'
                    });
                $('.stats-content').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({ 'class': "portlet-title" })
                    .css({
                        'content': '',
                        'min-height': '48px',
                        'padding': ' 0',
                        'border-bottom': '1px solid #eee',
                        'border-radius': '4px 4px 0 0',
                        'margin-bottom': '10px',
                        'box-sizing': 'border-box',
                    });
                $('.portlet').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({ 'class': "caption" })
                    .css({
                        'color': '#666',
                        'padding': '10px 0',
                        'display': 'inline-block',
                        'float': 'left',
                        'font-size': '18px',
                        'line-height': '18px',

                    });
                $('.portlet-title').append(divContent);

                var spanContent = jQuery($ewi.params.spanTag).attr({ 'class': "caption-subject" })
                    .css({
                        'font-size': '16px',
                        'color': '#4db3a2'
                    }).text($ewi.options.Heading);
                $('.caption').append(spanContent);
                divContent = jQuery($ewi.params.divTag).attr({ 'class': 'export-btn' }).css({
                    'display': 'inline-block',
                    'float': 'right',
                    'padding': '1%',
                    'float': 'right',
                    'position': 'relative',
                    'vertical-align': 'middle'
                });
                $('.portlet-title').append(divContent);
                var button = jQuery($ewi.params.aTag).attr({
                    'id': 'exportButton'
                }).css({
                    'background-color': '#44b6ae',
                    'color': '#ffffff',
                    'float': 'right',
                    'position': 'relative',
                    'border-radius': '25px',
                    'font-size': '13px',
                    'line-height': '1.5',
                    'padding': '4px 10px',
                    'outline': 'medium none',
                    'cursor': 'pointer',
                    'display': 'inline-block',
                    'font-weight': '400',
                    'text-align': 'center',
                    'vertical-align': 'middle',
                    'white-space': 'nowrap'
                }).text('Export');
                $('.export-btn').append(button);

                divContent = jQuery($ewi.params.divTag).attr({ 'class': 'filter-btn' }).css({
                    'display': 'inline-block',
                    'float': 'right',
                    'padding': '1%',
                    'float': 'right',
                    'position': 'relative',
                    'vertical-align': 'middle'
                });


                $('.portlet-title').append(divContent);
                var button = jQuery($ewi.params.aTag).attr({
                    'id': 'filterButton'
                }).css({
                    'background-color': '#44b6ae',
                    'color': '#ffffff',
                    'float': 'right',
                    'position': 'relative',
                    'border-radius': '25px',
                    'font-size': '13px',
                    'line-height': '1.5',
                    'padding': '4px 10px',
                    'outline': 'medium none',
                    'cursor': 'pointer',
                    'display': 'inline-block',
                    'font-weight': '400',
                    'text-align': 'center',
                    'vertical-align': 'middle',
                    'white-space': 'nowrap'
                }).text('Advanced Filter');
                $('.filter-btn').append(button);
                divContent = jQuery($ewi.params.divTag).attr({ 'class': 'customize-btn' }).css({
                    'display': 'inline-block',
                    'float': 'right',
                    'padding': '1%',
                    'float': 'right',
                    'position': 'relative',
                    'vertical-align': 'middle'
                });
                $('.portlet-title').append(divContent);
                var button = jQuery($ewi.params.aTag).attr({
                    'id': 'customizeButton'
                }).css({
                    'background-color': '#44b6ae',
                    'color': '#ffffff',
                    'float': 'right',
                    'position': 'relative',
                    'border-radius': '25px',
                    'font-size': '13px',
                    'line-height': '1.5',
                    'padding': '4px 10px',
                    'outline': 'medium none',
                    'cursor': 'pointer',
                    'display': 'inline-block',
                    'font-weight': '400',
                    'text-align': 'center',
                    'vertical-align': 'middle',
                    'white-space': 'nowrap'
                }).text('CustomizeList');
                $('.customize-btn').append(button);
                divContent = jQuery($ewi.params.divTag).attr({ 'class': "portlet-body" });
                $('.portlet').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "event-list table-scrollable table-scrollable-borderless"
                }).css({
                    'margin': '10px 0',
                    'overflow-x': 'auto',
                    'overflow-y': 'hidden',
                    'width': '100%',
                    'border-radius': '0',
                    'box-sizing': 'border-box'
                });
                $('.portlet-body').append(divContent);
                var customizeGuiDiv = '<div id="CustomizeGUI" style="box-sizing: border-box; overflow-x: hidden; overflow-y: auto; opacity: 1;outline: medium none; z-index: 10050; bottom: 0; display: none; left: 0; outline: 0 none; position: fixed; right: 0; top: 0; transition: opacity 0.15s linear 0s; border-radius: 0; "> <div class="modal-backdrop fade in" style="height: 1447px; height: 1447px; box-sizing: border-box; background-color: #333; opacity: 0.5; bottom: 0; position: fixed; border: 0 none; outline: medium none; z-index: 10049; left: 0; right: 0; top: 0; transition: opacity 0.15s linear 0s;border-radius: 0 !important;"></div> <div id="customizeDialog" class="modal-dialog" style=" background-color: #fff;box-sizing: border-box;transform: translate(0px, 0px);z-index: 10051; margin: 30px auto; width: 50%; position: relative;border-radius: 0 "> </div></div>';
                $('.customize-btn').append(customizeGuiDiv);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-content",
                    'id': "eventModalContent"
                }).css({
                    'box-sizing': 'border-box',
                    'box-shadow': '0 5px 15px rgba(0, 0, 0, 0.5)',
                    'background-clip': 'padding-box',
                    'background-color': '#fff',
                    'border': '1px solid rgba(0, 0, 0, 0.2)',
                    'border-radius': '6px',
                    'box-shadow': '0 3px 9px rgba(0, 0, 0, 0.5)',
                    'outline': '0 none',
                    'position': 'relative'
                });
                $('#customizeDialog').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-header",
                    'id': "eventModalHeader"
                }).css({
                    'box-sizing': 'border-box',
                    'border-bottom': '1px solid #efefef',
                    'min-height': '16.43px',
                    'padding': '15px'

                });
                $('#eventModalContent').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-body",
                    'id': "eventModalBody"
                }).css({
                    'box-sizing': 'border-box',
                    'padding': '15px',
                    'position': 'relative'

                });
                $('#eventModalContent').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-footer",
                    'id': "eventModalFooter"
                }).css({
                    'box-sizing': 'border-box',
                    'border-top': '1px solid #e5e5e5',
                    'padding': '15px',
                    'text-align': 'right',

                });
                $('#eventModalContent').append(divContent);
                divContent = jQuery($ewi.params.h4Tag).attr({
                    'class': "modal-title",

                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'padding': '15px',
                    'text-align': 'right',
                    'line-height': '1.42857',
                    'margin': '0',
                    'font-size': '17px',
                    'font-weight': '300'

                }).text('Select Columns');
                $('#eventModalHeader').append(divContent);
                var imageUrl  = $ewi.widgetPath + 'img/remove-icon-small.png';
                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "closeCustomizeModal"
                }).css({
                    'box-sizing': 'border-box',
                    'border-top': '1px solid #e5e5e5',
                    'padding': '15px',
                    'background': 'rgba(0, 0, 0, 0) none repeat scroll 0 0',
                    'background-image': 'url(' +imageUrl +')',
                    'background-repeat': 'no-repeat',
                    'display': 'inline-block',
                    'float': 'right',
                    'font-size': '21px',
                    'font-weight': '700',
                    'line-height': '1',
                    'opacity': '0.2',
                    'text-shadow': '0 1px 0 #fff',
                    'border': '0',
                    'cursor': 'pointer'
                });
                $('#eventModalHeader').append(buttonContent);
                var customizeForm = jQuery($ewi.params.formTag).attr({
                    'id': "customizeForm"
                }).css({
                    'box-sizing': 'border-box',

                });
                $('#eventModalBody').append(customizeForm);
                var customizeList = jQuery($ewi.params.ulTag).attr({
                    'id': "customizeList"
                }).css({
                    'box-sizing': 'border-box',
                    'list-style': 'outside none none',
                    'padding': '0',
                    'margin-bottom': '10px',
                    'margin-top': '0'

                });
                $('#customizeForm').append(customizeList);

                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "closeCustomizeModalButton"
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#e5e5e5',
                    'color': '#333333',
                    'border-width': '0',
                    'box-shadow': 'none',
                    'filter': 'none',
                    'font-size': '14px',
                    'outline': 'medium none !important',
                    'padding': '7px 14px',
                    'text-shadow': 'none'

                }).text('Close');
                $('#eventModalFooter').append(buttonContent);
                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "submitCustomizeModal"
                }).css({
                    'box-sizing': 'border-box',
                    'margin-bottom': '0',
                    'margin-left': '5px',
                    'background-color': '#26a69a',
                    'color': '#ffffff',
                    'border-width': '0',
                    'box-shadow': 'none',
                    'filter': 'none',
                    'font-size': '14px',
                    'outline': 'medium none !important',
                    'padding': '7px 14px',
                    'text-shadow': 'none'

                }).text('Submit');
                $('#eventModalFooter').append(buttonContent);
                var advancedFilterDiv = '<div id="AdvancedFilterModal" style="box-sizing: border-box; overflow-x: hidden; overflow-y: auto; opacity: 1;outline: medium none; z-index: 10050; bottom: 0; display: none; left: 0; outline: 0 none; position: fixed; right: 0; top: 0; transition: opacity 0.15s linear 0s; border-radius: 0; "> <div style="height: 1447px; height: 1447px; box-sizing: border-box; background-color: #333; opacity: 0.5; bottom: 0; position: fixed; border: 0 none; outline: medium none; z-index: 10049; left: 0; right: 0; top: 0; transition: opacity 0.15s linear 0s;border-radius: 0 !important;"></div> <div id="advancedFilterDialog" style=" background-color: #fff;box-sizing: border-box;transform: translate(0px, 0px);z-index: 10051; margin: 30px auto; width:50%; position: relative;border-radius: 0 "> </div></div>';
                $('.filter-btn').append(advancedFilterDiv);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-content",
                    'id': "filterModalContent"
                }).css({
                    'box-sizing': 'border-box',
                    'box-shadow': '0 5px 15px rgba(0, 0, 0, 0.5)',
                    'background-clip': 'padding-box',
                    'background-color': '#fff',
                    'border': '1px solid rgba(0, 0, 0, 0.2)',
                    'border-radius': '6px',
                    'box-shadow': '0 3px 9px rgba(0, 0, 0, 0.5)',
                    'outline': '0 none',
                    'position': 'relative'
                });
                $('#advancedFilterDialog').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-header",
                    'id': "filterModalHeader"
                }).css({
                    'box-sizing': 'border-box',
                    'border-bottom': '1px solid #efefef',
                    'min-height': '16.43px',
                    'padding': '15px'

                });
                $('#filterModalContent').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-body",
                    'id': "filterModalBody"
                }).css({
                    'box-sizing': 'border-box',
                    'position': 'relative',
                    'padding': '15px'


                });
                $('#filterModalContent').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-footer",
                    'id': "filterModalFooter"
                }).css({
                    'box-sizing': 'border-box',
                    'border-top': '1px solid #e5e5e5',
                    'padding': '15px',
                    'text-align': 'right',

                });
                $('#filterModalContent').append(divContent);
                divContent = jQuery($ewi.params.h4Tag).attr({
                    'class': "modal-title",

                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'padding': '15px',
                    'text-align': 'right',
                    'line-height': '1.42857',
                    'margin': '0',
                    'font-size': '17px',
                    'font-weight': '300'

                }).text('Advanced Filter');
                $('#filterModalHeader').append(divContent);
                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "closeFilterModal"
                }).css({
                    'box-sizing': 'border-box',
                    'border-top': '1px solid #e5e5e5',
                    'padding': '15px',
                    'background': 'rgba(0, 0, 0, 0) none repeat scroll 0 0',
                    'background-image': 'url('+imageUrl +')',
                    'background-repeat': 'no-repeat',
                    'display': 'inline-block',
                    'float': 'right',
                    'font-size': '21px',
                    'font-weight': '700',
                    'line-height': '1',
                    'opacity': '0.2',
                    'text-shadow': '0 1px 0 #fff',
                    'border': 'none',
                    'cursor': 'pointer'
                });
                $('#filterModalHeader').append(buttonContent);
                var filterForm = jQuery($ewi.params.formTag).attr({
                    'id': "filterForm"
                }).css({
                    'box-sizing': 'border-box',
                    'color': '#333333',
                    'font-size': '14px',
                    'line-height': '1.42857'

                });
                $('#filterModalBody').append(filterForm);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "filterDivElement0"
                }).css({
                    'box-sizing': 'border-box',
                    'content': '',
                    'display': 'table',
                    'margin-bottom': '15px',
                    'font-size': '13px',
                    'width': '100%',
                    'margin-left': '-15px',
                    'margin-right': '-15px',
                    'margin-bottom': '15px',
                    'border-radius': '0'


                });
                $('#filterForm').append(divContent);
                labelContent = jQuery($ewi.params.labelTag).text('Date Range').css({
                    'margin-bottom': '0',
                    'padding-top': '7px',
                    'text-align': 'right',
                    'margin-top': '1px',
                    'float': 'left',
                    'width': '25%',
                    'min-height': '1 px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'font-size': '14px',
                    'font-weight': '400',
                    'display': 'inline-block',
                    'line-height': '1.42857',
                    'font-size': '14px',
                    'max-width': '100%'



                });
                $('#filterDivElement0').append(labelContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "dateRangeDiv"
                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'width': '58.3333%',
                    'float': 'left',
                    'min-height': '1px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'border-radius': '0'

                });
                $('#filterDivElement0').append(divContent);
                inputElement = jQuery($ewi.params.inputTag).attr({
                    'id': 'fromDatePicker',
                    'type': 'text',
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#fff',
                    'box-sizing': 'border-box',
                    'border': '1px solid #e5e5e5',
                    'box-shadow': 'none',
                    'color': '#333',
                    'font-size': '14px',
                    'font-weight': 'normal',
                    'display': 'inline-block',
                    'width': '40%',
                    'transition': 'border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s',
                    'padding': '6px 12px',

                });

                jQuery('#dateRangeDiv').append(inputElement);

                spanContent = jQuery($ewi.params.spanTag).attr({
                    'id': "spanElement"
                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'width': '20%',
                    'text-align': 'center',
                    'font-size': '14px'

                }).text('to');
                jQuery('#dateRangeDiv').append(spanContent);
                inputElement = jQuery($ewi.params.inputTag).attr({
                    'id': 'toDatePicker',
                    'type': 'text',
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#fff',
                    'box-sizing': 'border-box',
                    'border': '1px solid #e5e5e5',
                    'box-shadow': 'none',
                    'color': '#333',
                    'font-size': '14px',
                    'font-weight': 'normal',
                    'display': 'inline-block',
                    'width': '40%',
                    'transition': 'border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s',
                    'padding': '6px 12px',

                });

                jQuery('#dateRangeDiv').append(inputElement)
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "filterDivElement1"
                }).css({
                    'box-sizing': 'border-box',
                    'content': '',
                    'display': 'table',
                    'margin-bottom': '15px',
                    'font-size': '13px',
                    'width': '100%',
                    'margin-left': '-15px',
                    'margin-right': '-15px',
                    'margin-bottom': '15px',
                    'border-radius': '0'


                });
                $('#filterForm').append(divContent);
                labelContent = jQuery($ewi.params.labelTag).text('Select Category').css({
                    'margin-bottom': '0',
                    'padding-top': '7px',
                    'text-align': 'right',
                    'margin-top': '1px',
                    'float': 'left',
                    'width': '25%',
                    'min-height': '1 px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'font-size': '14px',
                    'font-weight': '400',
                    'display': 'inline-block',
                    'line-height': '1.42857',
                    'font-size': '14px',
                    'max-width': '100%'



                });
                $('#filterDivElement1').append(labelContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "categorySelectDiv"
                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'width': '58.3333%',
                    'float': 'left',
                    'min-height': '1px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'border-radius': '0'

                });
                $('#filterDivElement1').append(divContent);
                selectContent = jQuery($ewi.params.selectTag).attr({
                    'id': "categorySelect"
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#fff',
                    'box-sizing': 'border-box',
                    'border': '1px solid #e5e5e5',
                    'box-shadow': 'none',
                    'color': '#333',
                    'font-size': '14px',
                    'font-weight': 'normal',
                    'display': 'inline-block',
                    'width': '100%',
                    'transition': 'border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s',
                    'display': 'block',
                    'padding': '6px 12px'


                });
                $('#categorySelectDiv').append(selectContent);

                optionContent = jQuery($ewi.params.optionTag).attr({
                    'id': "categoryOption",
                    "value": ""
                }).css({
                    'box-sizing': 'border-box',


                }).text("Select Category");
                $('#categorySelect').append(optionContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "filterDivElement2"
                }).css({
                    'box-sizing': 'border-box',
                    'content': '',
                    'display': 'table',
                    'margin-bottom': '15px',
                    'font-size': '13px',
                    'width': '100%',
                    'margin-left': '-15px',
                    'margin-right': '-15px',
                    'margin-bottom': '15px',
                    'border-radius': '0'


                });
                $('#filterForm').append(divContent);
                labelContent = jQuery($ewi.params.labelTag).text('Select Country').css({
                    'margin-bottom': '0',
                    'padding-top': '7px',
                    'text-align': 'right',
                    'margin-top': '1px',
                    'float': 'left',
                    'width': '25%',
                    'min-height': '1 px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'font-size': '14px',
                    'font-weight': '400',
                    'display': 'inline-block',
                    'line-height': '1.42857',
                    'font-size': '14px',
                    'max-width': '100%'



                });
                $('#filterDivElement2').append(labelContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "countrySelectDiv"
                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'width': '58.3333%',
                    'float': 'left',
                    'min-height': '1px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'border-radius': '0'

                });
                $('#filterDivElement2').append(divContent);
                selectContent = jQuery($ewi.params.selectTag).attr({
                    'id': "countrySelect"
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#fff',
                    'box-sizing': 'border-box',
                    'border': '1px solid #e5e5e5',
                    'box-shadow': 'none',
                    'color': '#333',
                    'font-size': '14px',
                    'font-weight': 'normal',
                    'display': 'inline-block',
                    'width': '100%',
                    'transition': 'border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s',
                    'display': 'block',
                    'padding': '6px 12px'


                });
                $('#countrySelectDiv').append(selectContent);
                optionContent = jQuery($ewi.params.optionTag).attr({
                    'id': "countryOption",
                    "value": ""
                }).css({
                    'box-sizing': 'border-box',


                }).text("Select Country");
                $('#countrySelect').append(optionContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "filterDivElement3"
                }).css({
                    'box-sizing': 'border-box',
                    'content': '',
                    'display': 'table',
                    'margin-bottom': '15px',
                    'font-size': '13px',
                    'width': '100%',
                    'margin-left': '-15px',
                    'margin-right': '-15px',
                    'margin-bottom': '15px',
                    'border-radius': '0'


                });
                $('#filterForm').append(divContent);
                labelContent = jQuery($ewi.params.labelTag).text('Select IP').css({
                    'margin-bottom': '0',
                    'padding-top': '7px',
                    'text-align': 'right',
                    'margin-top': '1px',
                    'float': 'left',
                    'width': '25%',
                    'min-height': '1 px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'font-size': '14px',
                    'font-weight': '400',
                    'display': 'inline-block',
                    'line-height': '1.42857',
                    'font-size': '14px',
                    'max-width': '100%'



                });
                $('#filterDivElement3').append(labelContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'id': "ipSelectDiv"
                }).css({
                    'box-sizing': 'border-box',
                    'display': 'inline-block',
                    'width': '58.3333%',
                    'float': 'left',
                    'min-height': '1px',
                    'padding-left': '15px',
                    'padding-right': '15px',
                    'position': 'relative',
                    'border-radius': '0'

                });
                $('#filterDivElement3').append(divContent);
                selectContent = jQuery($ewi.params.selectTag).attr({
                    'id': "ipSelect"
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#fff',
                    'box-sizing': 'border-box',
                    'border': '1px solid #e5e5e5',
                    'box-shadow': 'none',
                    'color': '#333',
                    'font-size': '14px',
                    'font-weight': 'normal',
                    'display': 'inline-block',
                    'width': '100%',
                    'transition': 'border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s',
                    'display': 'block',
                    'padding': '6px 12px'


                });
                $('#ipSelectDiv').append(selectContent);
                optionContent = jQuery($ewi.params.optionTag).attr({
                    'id': "ipOption",
                    "value": ""
                }).css({
                    'box-sizing': 'border-box',


                }).text("Select IPAddress");
                $('#ipSelect').append(optionContent);

                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "closeFilterModalButton"
                }).css({
                    'box-sizing': 'border-box',
                    'background-color': '#e5e5e5',
                    'color': '#333333',
                    'border-width': '0',
                    'box-shadow': 'none',
                    'filter': 'none',
                    'font-size': '14px',
                    'outline': 'medium none !important',
                    'padding': '7px 14px',
                    'text-shadow': 'none'

                }).text('Close');
                $('#filterModalFooter').append(buttonContent);
                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "submitFilterModal"
                }).css({
                    'box-sizing': 'border-box',
                    'margin-bottom': '0',
                    'margin-left': '5px',
                    'background-color': '#26a69a',
                    'color': '#ffffff',
                    'border-width': '0',
                    'box-shadow': 'none',
                    'filter': 'none',
                    'font-size': '14px',
                    'outline': 'medium none !important',
                    'padding': '7px 14px',
                    'text-shadow': 'none'

                }).text('Submit');
                $('#filterModalFooter').append(buttonContent);
                $('#filterButton').on('click', function(event) {
                    from = $("#fromDatePicker")
                        .datepicker({

                            'changeMonth': 'true',
                            'minDate': '-90',
                            'maxDate': '0',

                        })
                        .on("change", function() {
                            to.datepicker("option", "minDate", getDate(this));
                        }),
                        to = $("#toDatePicker").datepicker({

                            'changeMonth': 'true',
                            'minDate': '-90',
                            'maxDate': '0',

                        })
                        .on("change", function() {
                            from.datepicker("option", "maxDate", getDate(this));
                        });
                    var getDate = function(element) {

                        var date;
                        try {
                            date = $.datepicker.parseDate('mm/dd/yy', element.value);

                        } catch (error) {
                            date = null;
                        }

                        return date;
                    }

                    $("#fromDatePicker").datepicker("setDate", "-" + $ewi.options.defaultDays);
                    $("#toDatePicker").datepicker("setDate", "0");
                    $(this).off(event);

                });


                /* var eventList = $($ewi.params.tableTag).addClass($ewi.params.eventTableClass);
                 $(container).append(eventList);*/

                /* $('.portlet-title').append('<span class="caption-subject font-green-sharp" style="font-size: 16px;color: #4db3a2">Events</span> </div>');
                $('.portlet-title').append('<div class="btn-group pull-right"></div>');*/
                var eventList = $($ewi.params.tableTag).addClass($ewi.params.eventTableClass).css({
                    'background-color': '#fff',
                    'margin': '0',
                    'width': '100%',
                    'max-width': '100%',
                    'border-radius': 0,
                    'border-collapse': 'collapse',
                    'border-width': ' 0 0 1px',
                    'border-style': ' none none solid',
                    'border-color': '#efefef',
                });
                var organizationDetailsDiv = '<div id="organizationDetailsModal" style="display: block; box-sizing: border-box; overflow-x: hidden; overflow-y: auto; opacity: 1;outline: medium none; z-index: 10050; bottom: 0; display: none; left: 0; outline: 0 none; position: fixed; right: 0; top: 0; transition: opacity 0.15s linear 0s; border-radius: 0; "> <div style="height: 1447px; height: 1447px; box-sizing: border-box; background-color: #333; opacity: 0.5; bottom: 0; position: fixed; border: 0 none; outline: medium none; z-index: 10049; left: 0; right: 0; top: 0; transition: opacity 0.15s linear 0s;border-radius: 0 !important;"></div> <div id="organizationDialog" style=" background-color: #fff;box-sizing: border-box;transform: translate(0px, 0px);z-index: 10051; margin: 30px auto; width: 40%; position: relative;border-radius: 0 "> </div></div>';
                $(container).append(organizationDetailsDiv);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-content",
                    'id': "organizationModalContent"
                }).css({
                    'box-sizing': 'border-box',
                    'box-shadow': '0 5px 15px rgba(0, 0, 0, 0.5)',
                    'background-clip': 'padding-box',
                    'background-color': '#fff',
                    'border': '1px solid rgba(0, 0, 0, 0.2)',
                    'border-radius': '6px',
                    'box-shadow': '0 3px 9px rgba(0, 0, 0, 0.5)',
                    'outline': '0 none',
                    'position': 'relative'
                });
                $('#organizationDialog').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-header",
                    'id': "organizationModalHeader"
                }).css({
                    'box-sizing': 'border-box',
                    'border-bottom': '1px solid #efefef',
                    'min-height': '16.43px',
                    'padding': '15px'

                });
                $('#organizationModalContent').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-body",
                    'id': "organizationModalBody"
                }).css({
                    'box-sizing': 'border-box',
                    'position': 'relative',
                    'padding': '30px'


                });
                $('#organizationModalContent').append(divContent);
                divContent = jQuery($ewi.params.divTag).attr({
                    'class': "modal-footer",
                    'id': "organizationModalFooter"
                }).css({
                    'box-sizing': 'border-box',
                    'border-top': '1px solid #e5e5e5',
                    'padding': '15px',
                    'text-align': 'right',

                });
                $('#organizationModalContent').append(divContent);


                buttonContent = jQuery($ewi.params.buttonTag).attr({
                    'id': "closeOrganizationModal"
                }).css({
                    'box-sizing': 'border-box',
                    'border-top': '1px solid #e5e5e5',
                    'padding': '15px',
                    'background': 'rgba(0, 0, 0, 0) none repeat scroll 0 0',
                    'background-image': 'url(' +imageUrl +')','background-repeat': 'no-repeat',
                    'display': 'inline-block',
                    'float': 'right',
                    'font-size': '21px',
                    'font-weight': '700',
                    'line-height': '1',
                    'opacity': '0.2',
                    'text-shadow': '0 1px 0 #fff',
                    'border': 'none',
                    'cursor': 'pointer'
                });
                $('#organizationModalHeader').append(buttonContent);
                var divContent = jQuery($ewi.params.divTag).attr({'id':'loading'}).css({
                        'display': 'none',
                        'color': 'gray',
                        'color': 'gray',
                        'background-color':'#fff',
                        'font-size':'13px',
                       
                        'text-align': 'left',

                    }).text(' Loading ...');

                        
                    jQuery('.event-list').append(divContent);
                 var divContent = jQuery($ewi.params.divTag).attr({'id':'lastUpdated'}).css({
                        'display': 'block',
                        'color': 'gray',
                        'float': 'left',
                        'font-size': '11px',
                        'text-align': 'right',
                        'width': '100%',

                    }).text('');
                    jQuery('#' + $ewi.options.EventContainerId).append(divContent);
                    
                    

                //an initial JSON request for data


                getAdvancedFilterDetails('country_name');
                getAdvancedFilterDetails('ip_address');
                getAdvancedFilterDetails('category');
                getCustomFields();





                $('.event-list').append(eventList);
                jQuery($ewi.params.divTag).attr({
                    class: $ewi.params.paginationContainerClass
                }).css({ 'float': 'right' }).appendTo(container);

                $('#customizeButton').on('click', function() {

                    $('#CustomizeGUI').show();
                    $("#customizeList").sortable({
                        start: dragStart,
                        update: dragEnd
                    });


                });





                $('#filterButton').on('click', function() {


                    $('#AdvancedFilterModal').show();



                });
                $('#closeCustomizeModal').on('click', function() {

                    $('#CustomizeGUI').hide();


                });
                $('#submitCustomizeModal').on('click', function() {
                       /* jQuery('.SelectedField').each(function(){
                            if(jQuery(this).attr('checked')!== undefined){
                                console.log(jQuery(this).attr('id'));
                                $ewi.selectedCustomFields.push(jQuery(this).attr('id'));
                            }

                        });*/

                    jQuery.each($ewi.fields, function(j, field) {

                        //selectorValue = "#selectedField" + field.value;
                        /*console.log(selectorValue);
                        console.log($("#selectedField" + field.value).attr('checked') === 'checked')*/
                        if ($("#selectedField"+j).attr('checked') === 'checked') {
                            $ewi.fields[j].status = true;
                        } else {
                            $ewi.fields[j].status = false;
                        }
                        if (($ewi.fields[j].status === true) && $.inArray($ewi.fields[j].value, $ewi.customFields) !== -1) {
                            $ewi.selectedCustomFields.push($ewi.fields[j].value);
                        }





                    });
                    


                    getEvents();
                    $('#CustomizeGUI').hide();
                    /*  $('.SelectedField').each(function(element){
                        console.log(this);
                    });*/


                });
                $('#submitFilterModal').on('click', function() {





                    getEvents();
                    $('#AdvancedFilterModal').hide();
                    /*  $('.SelectedField').each(function(element){
                        console.log(this);
                    });*/


                });
                $('#exportButton').on('click', function() {

                    downloadData();


                });

                $('#closeOrganizationModal').on('click', function() {

                    $('#organizationDetailsModal').hide();


                });
                $('#closeFilterModal').on('click', function() {

                    $('#AdvancedFilterModal').hide();


                });
                $('#closeCustomizeModalButton').on('click', function() {

                    $('#CustomizeGUI').hide();


                });
                $('#closeFilterModalButton').on('click', function() {

                    $('#AdvancedFilterModal').hide();


                });




            });



        }

        function getCustomFields() {
            jQuery('#loading').show();
            var url = $ewi.options.ApiUrl + 'statistics/events/customData.json?projectApiKey=' + $ewi.options.ProjectApiKey + '&partyId=' + $ewi.options.PartyId + '&selectedReleaseStage=' + $ewi.options.ReleaseStage + '&startDate=' + $ewi.startDate + '&endDate=' + $ewi.endDate;
            fetchData(url, 'GET', 'json', 'async', function(result) {
                if (result.results.eventCustomData !== undefined) {
                    jQuery.each(result.results.eventCustomData, function(i, field) {
                        $ewi.customFields.push(field.value);
                        $ewi.fields.push({
                            "value": field.value,
                            "name": field.name,
                            "status": field.status
                        });

                    });
                    var customizeElement;
                    var spanContent;
                    var inputElement;
                    var dragImage  = $ewi.widgetPath + 'img/draggable-icon.png';

                    jQuery.each($ewi.fields, function(j, field) {
                        customizeElement = jQuery($ewi.params.liTag).attr({
                            'id': "customizeElement" + j
                        }).css({
                            'box-sizing': 'border-box',
                            'background': '#f9f9f9 url('+dragImage+') no-repeat scroll 12px center',
                            'border': '1px solid #e0e0e0',
                            'color': '#333',
                            'cursor': 'move',
                            'font-size': '14px',
                            'font-weight': '600',
                            'margin': '0 0 5px',
                            'min-width': '95%',
                            'padding': '7px 10px 7px 30px',
                            'min-height': '36px'


                        });
                        jQuery('#customizeList').append(customizeElement);
                        spanContent = jQuery($ewi.params.spanTag).attr({
                            'id': "customizeSpanElement" + j
                        }).css({
                            'box-sizing': 'border-box',
                            'display': 'inline-block'

                        }).text(field.name);
                        jQuery('#customizeElement' + j).append(spanContent);
                        divContent = jQuery($ewi.params.divTag).attr({
                            'id': "customizeDivElement" + j
                        }).css({
                            'box-sizing': 'border-box',
                            'display': 'inline-block',
                            'float': 'right'

                        });

                        jQuery('#customizeElement' + j).append(divContent);
                        inputElement = jQuery($ewi.params.inputTag).attr({
                            'class': "SelectedField",
                            "id": "selectedField" + j,
                            'type': "checkbox",
                            'value': field.value
                        }).css({
                            'box-sizing': 'border-box',

                        });
                        if (field.status === true) {
                            jQuery(inputElement).attr({ 'checked': 'checked' });
                        }
                        jQuery('#customizeDivElement' + j).append(inputElement);

                    });
                    getEvents();
                    jQuery('.' + $ewi.params.paginationContainerClass).pagination({
                        itemsOnPage: $ewi.options.recordLimit,
                        prevText: 'Previous',
                        nextText: 'Next',
                        displayedPages: 3,
                        hrefTextPrefix: 'javascript:void(',
                        hrefTextSuffix: ');',
                        onPageClick: function(pageNumber) {
                            getEvents(pageNumber);
                        },
                        cssStyle: 'compact-theme'
                    });


                } else {
                    jQuery('#loading').hide();
                    var divContent = jQuery($ewi.params.divTag).css({
                        'display': 'block',
                        'color': 'gray',
                        'background-color':'#fff',
                        'font-size':'13px',
                        'border-color': '#efefef',
                        'border-width': ' 0 0 1px',
                        'border-style': ' none none solid',
                        'text-align': 'left',
                        

                    }).text('No records found ');
                    jQuery('.event-list').append(divContent);
                }



            });
        }

        function formatDate(days, month, year) {
            if (days < 10) {
                days = '0' + days
            }

            if (month < 10) {
                month = '0' + month
            }

            today = month + '/' + days + '/' + year;
            return today;
        }

        function getDefaultEndDate() {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();


            return formatDate(dd, mm, yyyy);
        }

        function getDefaultStartDate() {
            var days; // Days you want to subtract
            var date = new Date();
            var last = new Date(date.getTime() - ($ewi.options.defaultDays * 24 * 60 * 60 * 1000));
            var days = last.getDate();
            var month = last.getMonth() + 1;
            var year = last.getFullYear();

            return formatDate(days, month, year);
        }

        function getEvents(pageNumber) {
            if(!pageNumber){    
                pageNumber = 1;
            }
            var eventTable = jQuery('.' + $ewi.params.eventTableClass);
            eventTable.html('');
            jQuery('#loading').show();
            var categoryFilter = jQuery('#categorySelect').val();
            var countryFilter = jQuery('#countrySelect').val();
            var ipFilter = jQuery('#ipSelect').val();
            var startDate = jQuery('#fromDatePicker').val();
            var endDate = jQuery('#toDatePicker').val();
            if (startDate) {
                $ewi.startDate = startDate;
            }
            if (endDate) {
                $ewi.endDate = endDate;
            }

            var url = $ewi.options.ApiUrl + 'statistics/events.json?projectApiKey=' + $ewi.options.ProjectApiKey + '&selectedReleaseStage=' + $ewi.options.ReleaseStage + '&partyId=' + $ewi.options.PartyId + '&startDate=' + $ewi.startDate + '&endDate=' + $ewi.endDate + '&category=&ipAddress=&country=&page=' + pageNumber + '&limit=' + $ewi.options.recordLimit + '&sortBy=&sortOrder=DESC&selectedCustomFields=' + $ewi.selectedCustomFields + '&category=' + categoryFilter + '&ipAddress=' + ipFilter + '&country=' + countryFilter;
            fetchData(url, 'GET', 'json', 'async', function(result) {
                $ewi.events = result.results.events;
                $ewi.totalEvents = result.results.eventsCount;
                if (result.results.cronTimeGap) {
                    
                    jQuery('#lastUpdated').text('');
                    
                }

                if (result.results.eventsCount === 0 || result.results.eventsCount <= $ewi.options.recordLimit) {
                    jQuery('.' + $ewi.params.paginationContainerClass).hide();
                } else {
                    jQuery('.' + $ewi.params.paginationContainerClass).show();
                    jQuery('.' + $ewi.params.paginationContainerClass).pagination('updateItems', result.results.eventsCount);

                }
                jQuery('#loading').hide();
                showEvent();

            });
        }


        function getAdvancedFilterDetails(type) {

            var url = $ewi.options.ApiUrl + 'statistics/events/filterDetails.json?projectApiKey=' + $ewi.options.ProjectApiKey + '&releaseStage=' + $ewi.options.ReleaseStage + '&startDate=' + $ewi.startDate + '&endDate=' + $ewi.endDate + '&filterParam=' + type;
            fetchData(url, 'GET', 'json', 'async', function(result) {

                if (type === 'category') {

                    jQuery.each(result.results.EventFilterList, function(i, value) {
                        if (jQuery.inArray(value.name, $ewi.categoryList) === -1) {
                            optionContent = jQuery($ewi.params.optionTag).attr({
                                'id': 'categoryOption',
                                'value': value.name
                            }).css({
                                'box-sizing': 'border-box',


                            }).text(value.name);
                            jQuery('#categorySelect').append(optionContent);
                        }

                        $ewi.categoryList.push(value.name);
                    });

                }
                if (type === 'country_name') {
                    jQuery.each(result.results.EventFilterList, function(i, value) {
                        if (jQuery.inArray(value.name, $ewi.countryList) === -1) {

                            optionContent = jQuery($ewi.params.optionTag).attr({
                                'id': "countryOption",
                                "value": value.name
                            }).css({
                                'box-sizing': 'border-box',


                            }).text(value.name);
                            jQuery('#countrySelect').append(optionContent);
                            $ewi.countryList.push(value.name);
                        }
                    });

                }
                if (type === 'ip_address') {
                    jQuery.each(result.results.EventFilterList, function(i, value) {
                        if (jQuery.inArray(value.name, $ewi.ipList) === -1) {

                            optionContent = jQuery($ewi.params.optionTag).attr({
                                'id': "ipOption",
                                "value": value.name
                            }).css({
                                'box-sizing': 'border-box',


                            }).text(value.name);
                            jQuery('#ipSelect').append(optionContent);
                            $ewi.ipList.push(value.name);
                        }
                    });


                }


            });
        }

        function downloadData() {

            var categoryFilter = jQuery('#categorySelect').val();
            var countryFilter = jQuery('#countrySelect').val();
            var ipFilter = jQuery('#ipSelect').val();
            var postDownload = {};
            postDownload.partyId = $ewi.options.PartyId;
            postDownload.projectApiKey = $ewi.options.ProjectApiKey;
            postDownload.selectedReleaseStage = $ewi.options.ReleaseStage;
            postDownload.category = categoryFilter;
            postDownload.ipAddress = ipFilter;
            postDownload.sortOrder = 'DESC';
            postDownload.sortBy = '';
            postDownload.country = countryFilter;
            postDownload.startDate = $ewi.startDate;
            postDownload.endDate = $ewi.endDate;
            postDownload.selectedCustomFields = $ewi.selectedCustomFields;
            postDownload.Fields = $ewi.fields;
            var field;
            var form = document.createElement("form");
            form.method = "POST";
            form.id = "tempForm";
            form.action = $ewi.options.ApiUrl + 'projects/eventData/download.json';
            document.body.appendChild(form);
            jQuery.each(postDownload, function(key, value) {
                field = document.createElement("input");
                field.setAttribute("type", "hidden");
                field.setAttribute("name", key);
                if (key === 'Fields') {
                    field.setAttribute("value", JSON.stringify(value));
                } else {
                    field.setAttribute("value", value);
                }

                form.appendChild(field);
            });
            document.body.appendChild(form);
            form.submit();
            var element = document.getElementById("tempForm");
            element.outerHTML = "";
        }

        function dragStart(e, ui) {
            ui.item.data('start', ui.item.index());

        }

        function dragEnd(e, ui) {
            var start = ui.item.data('start'),
                end = ui.item.index();

            $ewi.fields.splice(end, 0, $ewi.fields.splice(start, 1)[0]);
            jQuery('#selectedField'+start).addClass('temp');
            jQuery('#selectedField'+end).attr('id','selectedField'+start);
            jQuery('.temp').attr('id','selectedField'+end).removeClass('temp');


        }

        function showEvent() {

            var eventTable = jQuery('.' + $ewi.params.eventTableClass);
            eventTable.html('');
            if ($ewi.totalEvents > 0) {
                var headerRow = jQuery($ewi.params.rowTag).addClass('headerRowClass');
                jQuery(eventTable).append(headerRow);
                flag = 0;

                jQuery.each($ewi.fields, function(j, field) {


                    if (field.status === true) {
                        flag = 1;
                        //console.log(data[key]);
                        var headerCell = jQuery($ewi.params.headerColumnTag).text(field.name).css({
                            'border-color': '#efefef',
                            'color': '#93a2a9',
                            'font-weight': '600',
                            'padding': '9px',
                            'vertical-align': 'bottom',
                            'font-size': '13px',
                            'text-align': 'left',
                            'border-width': ' 0 0 1px',
                            'border-style': ' none none solid',

                        });
                        jQuery('.headerRowClass').append(headerCell);

                    }

                });

                jQuery.each($ewi.events, function(i, data) {
                    var bgcolor = '#fff';
                    if (i % 2 == 0) {
                        bgcolor = '#f9f9f9';
                    }
                    var parentRow = jQuery($ewi.params.rowTag).addClass('rowClass' + i).css({
                        'background-color': bgcolor
                    });
                    jQuery(eventTable).append(parentRow);

                    jQuery.each($ewi.fields, function(j, field) {

                        if (field.status === true) {


                            var key = field.value;
                            var cellValue;
                            if (data[key]) {
                                cellValue = data[key];
                            } else {
                                if (key === 'user_name') {
                                    cellValue = 'Anonymous';
                                } else {
                                    cellValue = 'Not Available';
                                }
                            }
                            //console.log(data[key]);
                            /*if (field.value === 'ip_address') {
                                var columnCell = jQuery($ewi.params.columnTag).attr({
                                    'id': 'ip_address' + i
                                }).css({
                                    'border-color': '#f2f5f8',
                                    'border-image': ' none',
                                    //'border-style': ' none none solid',
                                    'border-width': ' 0 0 1px',
                                    'color': ' #8896a0',
                                    'vertical-align': ' middle',
                                    'padding': '9px',
                                    'font-size': '13px'

                                });
                                jQuery('.rowClass' + i).append(columnCell);
                                var columnValue = jQuery($ewi.params.aTag).attr({
                                    'href': 'javascript:',
                                    'class': 'ipAddress',
                                    'value': cellValue
                                }).css({
                                    'color': '#5b9bd1',
                                    'text-shadow': 'none',
                                    'text-decoration': 'none',

                                }).text(cellValue);
                                jQuery('#ip_address' + i).append(columnValue);
                            } else {*/
                                var columnCell = jQuery($ewi.params.columnTag).text(cellValue).css({
                                    'border-color': '#f2f5f8',
                                    'border-image': ' none',
                                    //'border-style': ' none none solid',
                                    'border-width': ' 0 0 1px',
                                    'color': ' #8896a0',
                                    'vertical-align': ' middle',
                                    'padding': '9px',
                                    'font-size': '13px'

                                });
                                jQuery('.rowClass' + i).append(columnCell);
                            //}


                        }
                    });

                });
                if (flag === 0) {
                    var parentRow = jQuery($ewi.params.rowTag).addClass('rowClass');
                    jQuery(eventTable).append(parentRow);
                    var columnCell = jQuery($ewi.params.columnTag).text('No column selected').css({
                        'border-color': '#f2f5f8',
                        'border-image': ' none',
                        //'border-style': ' none none solid',
                        'border-width': ' 0 0 1px',
                        'color': ' #8896a0',
                        'vertical-align': ' middle',
                        'padding': '9px',
                        'font-size': '13px'

                    });;
                    jQuery('.rowClass').append(columnCell);
                }


            } else {
                var parentRow = jQuery($ewi.params.rowTag).addClass('rowClass');
                jQuery(eventTable).append(parentRow);
                var columnCell = jQuery($ewi.params.columnTag).text('No records found').css({
                    'border-color': '#f2f5f8',
                    'border-image': ' none',
                    //'border-style': ' none none solid',
                    'border-width': ' 0 0 1px',
                    'color': ' #8896a0',
                    'vertical-align': ' middle',
                    'padding': '9px',
                    'font-size': '13px'

                });;
                jQuery('.rowClass').append(columnCell);
            }
            jQuery('.ipAddress').on('click', function() {

                var ipAddress = jQuery(this).attr('value');
                url = $ewi.options.ApiUrl + 'statistics/ipInformation.json?&projectApiKey=' + $ewi.options.ProjectApiKey + '&userId=' + $ewi.options.PartyId + '&ipAddress=' + ipAddress;
                fetchData(url, 'GET', 'json', 'async', function(result) {
                    showOrganizationDetails(result.results.ipInformation);


                });




            });

        }
        this.showOrganizationDetails = function(ipInformation) {

                jQuery('#organizationDetailsModal').show();
                jQuery('#organizationModalBody').html('');
                var organizationTable = jQuery($ewi.params.tableTag).addClass('organizationTable').css({
                    'background-color': '#fff',
                    'margin': '15px',
                    'width': '100%',

                    'border-radius': 0,
                    'border-width': ' 0 0 1px',
                    'border-style': ' none none solid',
                    'border-color': '#efefef',

                });
                jQuery('#organizationModalBody').append(organizationTable);
                var headerRow = jQuery($ewi.params.rowTag).addClass('orgRow');
                jQuery('.organizationTable').append(headerRow);
                var headerCell = jQuery($ewi.params.headerColumnTag).text('Organization Information').css({
                    'border-color': '#efefef',
                    'color': '#666',
                    'font-weight': '500',
                    'font-family': 'sans-serif',
                    'padding': '9px',
                    'vertical-align': 'bottom',
                    'font-size': '15px',
                    'text-align': 'left',
                    'width': '100%',
                    'border-width': ' 0 0 1px',
                    'border-style': ' none none solid',
                    'border-color': '#efefef',


                });
                jQuery('.orgRow').append(headerCell);
                if (ipInformation.length > 0) {
                    orgDetails = ipInformation[0];

                    if (orgDetails.registrant_organization_name) {
                        orgName = orgDetails.registrant_organization_name;
                    } else if (orgDetails.admin_organization_name) {
                        orgName = orgDetails.admin_organization_name;
                    } else {
                        orgName = orgDetails.technical_organization_name;
                    }
                    if (orgDetails.registrant_street) {
                        orgStreet = orgDetails.registrant_street;
                    } else if (orgDetails.admin_street) {
                        orgStreet = orgDetails.admin_street;
                    } else {
                        orgStreet = orgDetails.technical_street;
                    }
                    if (orgDetails.registrant_city) {
                        orgCity = orgDetails.registrant_city;
                    } else if (orgDetails.admin_city) {
                        orgCity = orgDetails.admin_city;
                    } else {
                        orgCity = orgDetails.technical_city;
                    }

                    if (orgDetails.registrant_state) {
                        orgState = orgDetails.registrant_state;
                    } else if (orgDetails.admin_state) {
                        orgState = orgDetails.admin_state;
                    } else {
                        orgState = orgDetails.technical_state;
                    }
                    if (orgDetails.registrant_country) {
                        orgCountry = orgDetails.registrant_country;
                    } else if (orgDetails.admin_country) {
                        orgCountry = orgDetails.admin_country;
                    } else {
                        orgCountry = orgDetails.technical_country;
                    }
                    if (orgDetails.registrant_postal_code) {
                        orgPostCode = orgDetails.registrant_postal_code;
                    } else if (orgDetails.admin_postal_code) {
                        orgPostCode = orgDetails.admin_postal_code;
                    } else {
                        orgPostCode = orgDetails.technical_postal_code;
                    }
                    if (orgDetails.registrant_email) {
                        orgEmail = orgDetails.registrant_email;
                    } else if (orgDetails.admin_email) {
                        orgEmail = orgDetails.admin_email;
                    } else {
                        orgEmail = orgDetails.technical_email;
                    }
                    if (orgDetails.registrant_telephone) {
                        orgTelephone = orgDetails.registrant_telephone;
                    } else if (orgDetails.admin_telephone) {
                        orgTelephone = orgDetails.admin_telephone;
                    } else {
                        orgTelephone = orgDetails.technical_telephone;
                    }
                    var row = jQuery($ewi.params.rowTag).addClass('orgNameRow');
                    jQuery('.organizationTable').append(row);
                    var cell = jQuery($ewi.params.headerColumnTag).text(orgName).css({
                        'border-color': '#efefef',
                        'color': '#8896a0',
                        'font-weight': '500',
                        'font-family': 'sans-serif',
                        'padding': '9px',
                        'vertical-align': 'bottom',
                        'font-size': '13px',
                        'text-align': 'left',

                        'background-color': '#f9f9f9'

                    });
                    jQuery('.orgNameRow').append(cell);
                    var row = jQuery($ewi.params.rowTag).addClass('orgStreetRow');
                    jQuery('.organizationTable').append(row);
                    var cell = jQuery($ewi.params.headerColumnTag).text(orgStreet + ', ' + orgCity + ', ' + orgState + ', ' + orgCountry).css({
                        'border-color': '#efefef',
                        'color': '#8896a0',
                        'font-weight': '500',
                        'font-family': 'sans-serif',
                        'padding': '9px',
                        'vertical-align': 'bottom',
                        'font-size': '13px',
                        'text-align': 'left',


                    });
                    jQuery('.orgStreetRow').append(cell);

                    var row = jQuery($ewi.params.rowTag).addClass('orgPostCodeRow');
                    jQuery('.organizationTable').append(row);
                    var cell = jQuery($ewi.params.headerColumnTag).text(orgPostCode).css({
                        'border-color': '#efefef',
                        'color': '#8896a0',
                        'font-weight': '500',
                        'font-family': 'sans-serif',
                        'padding': '9px',
                        'vertical-align': 'bottom',
                        'font-size': '13px',
                        'text-align': 'left',

                        'background-color': '#f9f9f9'

                    });
                    jQuery('.orgPostCodeRow').append(cell);
                    var row = jQuery($ewi.params.rowTag).addClass('orgEmailRow');
                    jQuery('.organizationTable').append(row);
                    var cell = jQuery($ewi.params.headerColumnTag).text(orgEmail).css({
                        'border-color': '#efefef',
                        'color': '#8896a0',
                        'font-weight': '500',
                        'font-family': 'sans-serif',
                        'padding': '9px',
                        'vertical-align': 'bottom',
                        'font-size': '13px',
                        'text-align': 'left',

                    });
                    jQuery('.orgEmailRow').append(cell);
                    var row = jQuery($ewi.params.rowTag).addClass('orgTelephoneRow');
                    jQuery('.organizationTable').append(row);
                    var cell = jQuery($ewi.params.headerColumnTag).text(orgTelephone).css({
                        'border-color': '#efefef',
                        'color': '#8896a0',
                        'font-weight': '500',
                        'font-family': 'sans-serif',
                        'padding': '9px',
                        'vertical-align': 'bottom',
                        'font-size': '13px',
                        'text-align': 'left',

                        'background-color': '#f9f9f9'

                    });
                    jQuery('.orgTelephoneRow').append(cell);




                } else {
                    var row = jQuery($ewi.params.rowTag).addClass('orgNameRow');
                    jQuery('.organizationTable').append(row);
                    var cell = jQuery($ewi.params.headerColumnTag).text('Sorry no information!').css({
                        'border-color': '#efefef',
                        'color': '#8896a0',
                        'font-weight': '500',
                        'font-family': 'sans-serif',
                        'padding': '9px',
                        'vertical-align': 'bottom',
                        'font-size': '13px',
                        'text-align': 'left',

                        'background-color': '#f9f9f9'

                    });
                    jQuery('.orgNameRow').append(cell);
                }




            }
            /******** FETCH DATA ********/
        this.fetchData = function(path, methodType, type, async, callback, accessToken) {

            return jQuery.ajax({
                url: path,
                crossDomain: true,
                async: async,
                xhrFields: {
                    withCredentials: false
                },
                beforeSend: function(xhrObj) {

                },
                type: 'GET',
                dataType: type,
                success: function(data) {
                    callback(data);

                },
                error: function(e) {
                    //console.log(e);
                }
            });
        };
    }
    return {
        getInstance: function(config) {
            config.widgetPath = widgetPath;
            if (!instance) {
                instance = createInstance(config);
            }
            return instance;
        }
    };
})();



// WEBPACK FOOTER //
// src/assets/telemetry-event-widget/lib/event-widget.js